import axios from "axios";
import { keycloakService } from "./keycloakService";

const apiGateway = axios.create({
    baseURL: window.__RUNTIME_CONFIG__.REACT_APP_APIGATEWAY_URL,
    headers: {
        "Content-Type": "application/json",
    }
});

const configure = () => {
    apiGateway.defaults.validateStatus = function () {
        return true;
    };

    apiGateway.interceptors.request.use((config) => {
        if (keycloakService.isLoggedIn()) {
            const cb = () => {
                if (!config.headers) {
                    console.error("HTTP headers are somehow undefined");
                    return Promise.reject();
                }
                config.headers.Authorization = `Bearer ${keycloakService.getToken()}`;
                return Promise.resolve(config);
            };
            return keycloakService.updateToken(cb);
        }
        return config;
    });

};

export const apiClientService = {
    apiGateway: apiGateway,
    configure,
};

export type ApiGateWayResponse<T> = {
  data?: T;
  error?: {
    message: string;
  };
};
